module.exports = __webpack_public_path__ + "media/clap-fake.6d74ef36.mp3";